import { ReactNode } from 'react';
import { X } from 'lucide-react';

export interface ModalHeaderProps {
  title: string;
  icon?: ReactNode;
  onClose: () => void;
  subtitle?: string;
}

/**
 * Standardized modal header component with:
 * - Optional icon
 * - Title and optional subtitle
 * - Close button
 * - Consistent styling
 */
export function ModalHeader({ title, icon, onClose, subtitle }: ModalHeaderProps) {
  return (
    <div data-tsx-id="modal-header" className="flex justify-between items-start p-4 sm:p-6 border-b border-zinc-200">
      <div className="flex items-center flex-1">
        {icon && (
          <div className="p-2 bg-blue-100 rounded-full mr-3 flex-shrink-0">
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <h2 className="text-lg sm:text-xl font-semibold text-zinc-900 truncate">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs sm:text-sm text-zinc-500 mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <button
        onClick={onClose}
        className="text-zinc-400 hover:text-zinc-500 transition-colors flex-shrink-0 ml-4"
        aria-label="Close modal"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
